<mat-card appearance="outlined" [class.mat-subform-open-card]="subform?.open">
    <mat-card-header>
        <mat-card-title class="mat-card-title-header">
            <div class="header-wrapper">
                <span class="title-wrapper">
                    <ng-content select="[mgdFormSectionIcon]"></ng-content>
                    <ng-content select="[mgdFormSectionHeader]"></ng-content>
                </span>
                @if (headerDescription) {
                <span class="description-wrapper">
                    <ng-content select="[mgdFormSectionHeaderDescription]"></ng-content>
                </span>
                }
            </div>
        </mat-card-title>
    </mat-card-header>
    <mgd-card-content class="mat-card-content-form-section">
        <ng-content></ng-content>
    </mgd-card-content>
</mat-card>